<div class="table-header-group-wrapper">
	<ng-content/>
</div>
